import React from 'react'
import NotFounDData from "@assets/images/not-found.svg" 
import "@assets/css/NotFound.css"
const NotFound = ({message="",recipeDetail = false}) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          height: "auto",
          alignItems: "center",
          flexDirection: "column",
          marginTop:"10px"
        }}
      >
        <img src={NotFounDData} className='notFoundImage'/>
        <div className="notFoundText mt-2" style={{ color: recipeDetail ? "#fff":"#8E8E93" }}>
         {message}
        </div>
      </div>
    );
}

export default NotFound;